import { emitClickComponent } from '@royalaholddelhaize/ah-analytics';
import {
    ComponentSubType,
    ComponentType,
} from '@royalaholddelhaize/ah-self-service-toolkit';

export const emitLoadMoreClick = (innerText: string, targetUrl: string) => {
    emitClickComponent({
        componentType: ComponentType.REGULAR_BUTTON,
        componentSubType: ComponentSubType.BUTTON,
        componentInnerText: innerText,
        componentTargetUrl: targetUrl,
        componentAdditional: 'More results button',
    });
};
